import chatIcon from "../../../../assets/images/icons/chatIcon.svg"
import "./onboarding-complete.scss"
import {useContext, useEffect, useState} from "react";
import {useIntercom} from "react-use-intercom";
import customAxios from "../../../../service/api/interceptors";
import {MainContextProvider} from "../../../../context/MainContext";
import {da} from "date-fns/locale";
import moment from "moment";

export const OnBoardingComplete = () => {
    const { userData } = useContext(MainContextProvider);
    const { showNewMessages } = useIntercom();
    const [date, setDate] = useState<null | string>(null)
    const [link, setLink] = useState("")

    const getData = async () => {
        try {
            const { data, status } = await customAxios.get(`/flow/onboarding`)
            if (status === 200) {
                const action = data.find((el: any) => el.action === "Calendly-book")
                if (action?.data?.data) {
                    const call = JSON.parse(action.data.data)
                    setLink(call.link)
                    setDate(call.time)
                }

                if (!action) {
                    // /call/list?status_list[]=0&company_id=8350
                    // ooo8@dasadssad.com
                    // /call/list?status_list[]=0&company_id=7338
                    const { status, data } = await customAxios.get(`/call/list?status_list[]=0&company_id=${userData?.companies[0].id}`)
                    if (status === 200 && data && data.calls && data.calls.length > 0) {
                        const call = data.calls[0]
                        setLink(call.link)
                        setDate(moment(call.date * 1000).format('DD/MM/YYYY HH:mm'))
                    }
                }
            }
        } catch (e) {}
    }

    useEffect(() => {
        getData()
    },[])

    return (
        <div className={"w100 flex-center"}>
            <div className={"onboarding-complete"}>
                <h4>ONBOARDING COMPLETE</h4>
                <h1>Congratulations! You`ve completed<br /> your onboarding! </h1>
                <p>
                    Your <b>Legal Discovery Session</b> is booked for <b>{date}</b>.
                    During this session, our industry expert will discuss your project needs in detail and suggest legal works to drive your project forward.
                    Think about any open questions you`d like to address!
                </p>
                <p>
                    We are finalising your account and project setup.
                    Within 24 hours, you`ll get an introduction to your <b>Virtual Legal Officer (VLO) and gain full platform access!</b>
                </p>
                <a style={{ textDecoration: "none" }} target={"_blank"} href={link}>
                    <button disabled={!link} className={"btn-black w40"} style={{ margin: "18px auto 0 auto", display: "block" }}>JOIN</button>
                </a>
                <div className={"onboarding-complete__chat"}>
                    <img src={chatIcon} alt=""/>
                    <span>
                        Have any questions? Contact us anytime via <a onClick={() => showNewMessages("")}>chat!</a>
                    </span>
                </div>
                <h3>We`re excited to support you – welcome aboard!</h3>
            </div>
        </div>
    )
}